import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import checkIsValidId from "@/router/middlewares/checkIsValidId";
import { redirectToNotFoundPage } from '@/middlewares/axios/handler/global-http-not-found-handler';

export default function beforeEnterCheck(to, from, next) {
  if (checkIsValidId(to.params.id)) {
    checkAuthenticated(to, from, next);
  } else {
    redirectToNotFoundPage();
  }
}